export default function CleanProjectNames(name) {

    const project_name = name.split(' ')
        .map(word => word.includes('-')
            ? word.split('-')
                .map(part => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
                .join('-')
            : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(' ')

    return project_name;
}